import React from "react";

export default function UltrasoundTabSkeleton() {
  return (
    <div className="bg-white rounded-lg shadow border p-4 animate-pulse">
      {/* Filters Skeleton */}
      <div className="mb-4 flex items-center gap-3 flex-wrap">
        <div className="h-10 w-1/4 min-w-[200px] bg-gray-200 rounded"></div>
        <div className="h-10 w-32 bg-gray-200 rounded"></div>
        <div className="h-10 w-32 bg-gray-200 rounded"></div>
        <div className="h-10 w-32 bg-gray-200 rounded"></div>
        <div className="h-10 w-20 bg-gray-200 rounded"></div>
      </div>

      {/* Month Block */}
      {[1, 2].map((m) => (
        <div key={m} className="mb-4 border rounded-lg overflow-hidden">
          {/* Month Header */}
          <div className="p-3 bg-gray-100 flex justify-between items-center">
            <div className="h-4 w-32 bg-gray-300 rounded"></div>
            <div className="h-4 w-24 bg-gray-300 rounded"></div>
          </div>

          {/* Dates */}
          {[1, 2].map((d) => (
            <div
              key={d}
              className="ml-4 mt-2 border rounded-lg overflow-hidden"
            >
              {/* Date Header */}
              <div className="p-2 bg-gray-50 flex justify-between items-center">
                <div className="h-4 w-24 bg-gray-200 rounded"></div>
                <div className="h-4 w-16 bg-gray-200 rounded"></div>
              </div>

              {/* Radiologist Groups */}
              {[1, 2].map((g) => (
                <div key={g} className="mb-2 border rounded-lg mx-2">
                  <div className="p-2 bg-gray-50 flex justify-between">
                    <div className="flex flex-col gap-1">
                      <div className="h-3 w-28 bg-gray-200 rounded"></div>
                      <div className="h-3 w-20 bg-gray-200 rounded"></div>
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="h-6 w-10 bg-gray-200 rounded"></div>
                      <div className="h-3 w-10 bg-gray-200 rounded"></div>
                      <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
                    </div>
                  </div>

                  {/* Table Skeleton */}
                  <div className="p-2">
                    {[1, 2, 3].map((r) => (
                      <div
                        key={r}
                        className="grid grid-cols-5 gap-3 border-b py-2"
                      >
                        <div className="h-3 bg-gray-200 rounded"></div>
                        <div className="h-3 bg-gray-200 rounded"></div>
                        <div className="h-3 bg-gray-200 rounded"></div>
                        <div className="h-3 bg-gray-200 rounded"></div>
                        <div className="h-3 bg-gray-200 rounded"></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
